var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsdc = function SvgUsdc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 101 100"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#usdc_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: 0.299,
    fill: "#2775CA",
    rx: 50
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.047 57.891c0-7.286-4.372-9.785-13.118-10.83-6.247-.834-7.496-2.498-7.496-5.412s2.084-4.787 6.247-4.787c3.748 0 5.832 1.25 6.871 4.372.21.625.835 1.04 1.46 1.04h3.333c.834 0 1.459-.625 1.459-1.46v-.21c-.834-4.582-4.583-8.12-9.37-8.535v-4.997c0-.835-.625-1.46-1.664-1.665h-3.124c-.835 0-1.46.625-1.664 1.665v4.787c-6.247.835-10.205 4.998-10.205 10.205 0 6.872 4.163 9.58 12.909 10.62 5.832 1.04 7.706 2.289 7.706 5.622s-2.914 5.622-6.872 5.622c-5.412 0-7.286-2.289-7.91-5.412-.21-.835-.835-1.25-1.46-1.25H37.61c-.835 0-1.46.625-1.46 1.46v.21c.835 5.207 4.163 8.955 11.035 9.995v4.997c0 .835.624 1.46 1.664 1.664h3.124c.834 0 1.459-.624 1.664-1.664v-4.997c6.242-1.045 10.41-5.418 10.41-11.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.684 79.755c-16.242-5.832-24.572-23.948-18.53-39.98 3.123-8.745 9.995-15.407 18.53-18.53.835-.415 1.25-1.04 1.25-2.085v-2.913c0-.835-.415-1.46-1.25-1.664-.21 0-.624 0-.834.21C19.07 21.04 8.24 42.069 14.487 61.854 18.235 73.514 27.19 82.47 38.85 86.217c.834.415 1.664 0 1.874-.834.21-.21.21-.415.21-.835v-2.914c0-.63-.625-1.459-1.25-1.879m22.07-64.967c-.835-.415-1.665 0-1.875.834-.21.21-.21.415-.21.835v2.913c0 .835.625 1.665 1.25 2.084 16.242 5.832 24.572 23.948 18.53 39.98-3.123 8.746-9.995 15.408-18.53 18.531-.835.415-1.25 1.04-1.25 2.084v2.914c0 .834.415 1.459 1.25 1.664.21 0 .624 0 .834-.21 19.78-6.247 30.61-27.276 24.363-47.062-3.748-11.864-12.908-20.82-24.363-24.567"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "usdc_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: 0.299,
    fill: "#fff",
    rx: 50
  })))));
};
export default SvgUsdc;